import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import clsx from 'clsx';
import { pick } from '../utils';
import Icon from '../icon';
import Loading from '../loading';
import Popup from '../popup';
import { sharedPopupProps } from '../popup/Popup';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var ActionSheet = function ActionSheet(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('action-sheet', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var onCancel = function onCancel() {
    var _props$onClose, _props$onCancel;

    (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    (_props$onCancel = props.onCancel) === null || _props$onCancel === void 0 ? void 0 : _props$onCancel.call(props);
  };

  var renderHeader = function renderHeader() {
    if (!props.title) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('header'))
    }, props.title, props.closeable && (typeof props.closeIcon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
      name: props.closeIcon,
      className: clsx(bem('close')),
      onClick: onCancel
    }) : /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('close')),
      onClick: onCancel
    }, props.closeIcon)));
  };

  var renderCancel = function renderCancel() {
    if (!props.cancelText) return null;
    return [/*#__PURE__*/React.createElement("div", {
      key: "cancel-gap",
      className: clsx(bem('gap'))
    }), /*#__PURE__*/React.createElement("button", {
      key: "cancel-btn",
      type: "button",
      className: clsx(bem('cancel')),
      onClick: onCancel
    }, props.cancelText)];
  };

  var renderOption = function renderOption(item, index) {
    var name = item.name,
        color = item.color,
        subname = item.subname,
        loading = item.loading,
        callback = item.callback,
        disabled = item.disabled,
        className = item.className,
        style = item.style;
    var Content = loading ? /*#__PURE__*/React.createElement(Loading, {
      className: clsx(bem('loading-icon'))
    }) : [/*#__PURE__*/React.createElement("span", {
      key: "".concat(index, "-1"),
      className: clsx(bem('name'))
    }, name), subname && /*#__PURE__*/React.createElement("div", {
      key: "".concat(index, "-2"),
      className: clsx(bem('subname'))
    }, subname)];

    var onClick = function onClick() {
      if (disabled || loading) {
        return;
      }

      if (callback) {
        callback(item);
      }

      if (props.closeOnClickAction) {
        onCancel();
      }

      setTimeout(function () {
        var _props$onSelect;

        (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, item, index);
      }, 0);
    };

    return /*#__PURE__*/React.createElement("button", {
      key: index,
      type: "button",
      style: _objectSpread({
        color: color
      }, style),
      className: clsx(bem('item', {
        loading: loading,
        disabled: disabled
      }), className),
      onClick: onClick
    }, Content);
  };

  var renderDescription = function renderDescription() {
    if (props.description) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('description'))
      }, props.description);
    }

    return null;
  };

  var renderOptions = function renderOptions() {
    if (props.actions) {
      return props.actions.map(renderOption);
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(Popup, _extends({
    visible: props.visible,
    className: clsx(bem()),
    position: "bottom"
  }, pick(props, sharedPopupProps), {
    onClose: onCancel,
    closeable: false
  }), renderHeader(), renderDescription(), /*#__PURE__*/React.createElement("div", {
    className: clsx(bem('content'))
  }, renderOptions(), props.children), renderCancel());
};

ActionSheet.defaultProps = {
  closeIcon: 'cross',
  closeable: true,
  safeAreaInsetBottom: true,
  round: true,
  lockScroll: true,
  overlay: true,
  closeOnClickOverlay: true
};
export default ActionSheet;